<template>
  <div class="content if-profile">
    <div class="md-layout ratios-report">
      <MRReportHeader :headerData="this.headerData" />
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 marketprof-competitors p-0"
      >
        <!-- <div class="finanical-report-messages">
          <h1 class="md-subheading profile-title">Market Area Demographics</h1>
          <div class="">
            <md-dialog :md-active.sync="showDialog">
              <p>Population demographics are applied from the Census Bureau's American Community Survey.
                Data for zip-county-metro-state and US markets are applied directly. Demographic totals for
                radius-based markets are applied at the level of aggregated zip codes which are co-joined to
                the selected market radius. Elements of this data are also integrated into our Sales per Person
                and Sales per Household calculations displayed on the Penetration>Table tab.
              </p>
            </md-dialog>
            <md-card-header class="md-card-header-icon messages-box">
              <div class="card-icon md-ripple" @click="showDialog = true">
                <md-icon class="icon-arrow">double_arrow </md-icon>
                <md-icon>chat_bubble</md-icon>
              </div>
            </md-card-header>
          </div>
        </div>-->
        <div class="md-transparent finanical-report-messages blue-tbl demographics p-0">
          <nav-tabs-card class="p-0 m-0">
            <template slot="content">
              <!-- <div class="md-layout demographics-button">
                <div class="md-layout-item md-medium-size-100 md-size-10" value="right">
                  <span class="actions ml-5">
                    <a href="/new-profile/industry-market-profile" class="md-button md-info md-block btn-sm md-theme-default" target="_blank">
                      <div class="md-ripple">
                        <div class="md-button-content">ADD AREAS</div>
                      </div>
                    </a>
                  </span>
                </div>
              </div>-->
              <div class="md-layout">
                <md-card class="if_card">
                  <md-card-header>
                    Market Area Demographics
                    <a
                      href="/new-profile/industry-market-profile"
                      class="md-button md-info btn-sm md-theme-default"
                      target="_blank"
                    >
                      <div class="md-ripple">
                        <div class="md-button-content">ADD AREAS</div>
                      </div>
                    </a>
                  </md-card-header>
                  <md-card-content>
                    <div class="md-layout mt-4 mb-4">
                      <div class="md-layout-item md-medium-size-100 md-size-100">
                        <ul
                          class="favorite-list companis-list-tabl competitors-list px-4 m-0"
                          v-if="Object.values(demographics).length"
                        >
                          <li
                            v-for="(categoryData, category) in demographics"
                            :key="category"
                            class="favorite-list-item map-content p-0"
                          >
                            <collapse
                              :collapse="[category]"
                              icon="keyboard_arrow_down"
                              color-collapse="info"
                              value="left"
                              :active="true"
                            >
                              <template :slot="`md-collapse-pane-1`">
                                <md-card-content>
                                  <!-- <div class="md-layout"> -->
                                  <div
                                    class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                                  >
                                    <md-table
                                      v-for="(table, index) in categoryData"
                                      :key="index + '_category'"
                                      table-header-color="blue"
                                      class="collapse_table"
                                    >
                                      <md-table-row
                                        v-for="(item, name) in table"
                                        :key="name + index + category + '_each'"
                                      >
                                        <md-table-cell class="md-table-side-label">{{ name }}</md-table-cell>
                                        <md-table-cell
                                          v-for="(key, i) in item"
                                          :key="key + i"
                                        >{{ key }}</md-table-cell>
                                      </md-table-row>
                                    </md-table>
                                  </div>
                                  <!-- </div> -->
                                </md-card-content>
                              </template>
                            </collapse>
                          </li>
                        </ul>
                      </div>
                      <div class="md-layout-item md-medium-size-100 md-size-100">
                        <md-card class="md-card-profile px-4 mt-0">
                          <md-card-header>
                            <h4 class="title m-0">
                              <div
                                class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                              >
                                <md-icon class="color-white">article</md-icon> Competitive Market Narrative
                              </div>
                            </h4>
                          </md-card-header>
                          <md-card-content>
                            <div class="extra_space">
                              <p>
                               {{cmnText.demographics}}
                              </p>
                            </div>
                          </md-card-content>
                        </md-card>
                      </div>
                      <div class="md-layout-item md-medium-size-100 md-size-100">
                        <md-card class="md-card-profile px-4 mt-0">
                          <md-card-header>
                            <h4 class="title m-0">
                              <div
                                class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                              >
                                <md-icon class="color-white">article</md-icon> Demographics
                              </div>
                            </h4>
                          </md-card-header>
                          <md-card-content>
                            <div class="extra_space">
                              <p>
                                Population demographics are applied from the Census Bureau's American Community Survey.
                                Data for zip-county-metro-state and US markets are applied directly. Demographic totals for
                                radius-based markets are applied at the level of aggregated zip codes which are co-joined to
                                the selected market radius. Elements of this data are also integrated into our Sales per Person and Sales
                                per Household calculations displayed on the Penetration>Table tab.
                              </p>
                            </div>
                          </md-card-content>
                        </md-card>
                      </div>
                    </div>
                  </md-card-content>
                </md-card>
                <!-- <md-card>
                  <md-card-content>
                    <div class="md-layout">
                      <div class="md-layout-item md-medium-size-100 md-size-100">
                        <div class="md-card-header md-card-header-icon md-card-header-blue"></div>
                          <h4 class="Performance Scores">
                            Competitive Market Narrative
                          </h4>
                          <p>
                            This competitive industry market area analysis includes the Birmingham AL Metro Area.
                            In October​ 2017, the market area economy supports a total private sector business base
                            of 56,169 local​ operations.<br><br>
                            Total population in the market area is 1,138,476 including 505,097 households with a
                            median age of​ 38. 28.3% of the population boasts a bachelor’s degree or higher;
                            another 7.8% holds an associate​ degree.<br><br>
                            Median housing value in the market area is $146,200, while the median rent level
                            is $795 per month.​ Per capita income in the market area is $26,977, while average
                            (mean) household income is $58,917​ and median household income is $42,728. 19.89%
                            of market area households earn over one hundred​ thousand dollars per year.<br><br>
                            Population demographics are applied from the Census Bureau's American Community Survey.
                            Data​ for zip-county-metro-state and US markets are applied directly. Demographic totals
                            for radius-based​ markets are applied at the level of aggregated zip codes which are
                            co-joined to the selected market radius.
                          </p>
                      </div>
                    </div>
                  </md-card-content>
                </md-card>-->
              </div>
            </template>
          </nav-tabs-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Collapse } from '@/components';
import { NavTabsCard } from '@/components';
import { mapState } from 'vuex';
import MRReportHeader from './_partials/MRReportHeader.vue';

export default {
  components: {
    NavTabsCard,
    Collapse,
    MRReportHeader,
  },
  props: ['headerData'],
  data() {
    return {
      view: 'tableDataMarketAnnualSalesy',
      showDialog: false,
    };
  },
  computed: {
    ...mapState({
      demographics: (state) =>
        state.user.market_report.data.data['demographics'],
      years: (state) => state.user.market_report.data.years,
      cmnText: (state) =>state.user.market_report.cmnText, 
    }),
  },
  mounted() {

    let section = this.$route.query.section;

    if (!section) {
      section = 'tableDataMarketAnnualSales';
    }

    this.switchView(section);
  },
  watch: {
    '$route.query.section'() {
      let section = this.$route.query.section;

      if (!section) {
        section = 'tableDataMarketAnnualSales';
      }

      this.switchView(section);
    },
  },
  methods: {
    switchView: function (type) {
      this.view = type;
    },
  },
};
</script>

<style lang="scss">
.demographics-button {
  display: flex;
  justify-content: flex-end;
}
</style>
